import { RedirectService } from './redirect.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from './login.service';
import { LoginComponent } from './login.component';
import { TokenInterceptor } from './token.intercepter';
import { LayoutComponent } from './layout.component';
import { LandingFooterComponent } from './landing-footer/landing-footer.component';
import { CmsPageTypes } from './landing-footer/cms-page-types';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { FormsModule } from '@angular/forms';
import { LoginModule as SecoLoginModule } from '@seco/login';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';
import { PipesModule } from '../pipes';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderAlertModule } from '../header-alert';
import { EffectsModule } from '@ngrx/effects';
import { CoreEffects } from './core.effects';

@NgModule({
  imports: [
    NgSelectModule,
    NgxPageScrollModule,
    FormsModule,
    SecoLoginModule,
    CommonModule,
    RouterModule,
    PipesModule,
    NgbTooltipModule,
    HeaderAlertModule,
    EffectsModule.forFeature([CoreEffects])
  ],
  declarations: [
    LoginComponent, 
    LayoutComponent, 
    CookieBannerComponent, 
    LandingFooterComponent
  ],
  exports: [LoginComponent, LayoutComponent, CookieBannerComponent, LandingFooterComponent],
  providers: [LoginService, RedirectService, CookieService, TokenInterceptor, CmsPageTypes]
})
export class LoginModule {}
